const onChangeColumnVisiblity = function (newModel) {
  this.collection.visibleColumns = newModel
}

export default onChangeColumnVisiblity
